import { render } from "./Pesos.vue?vue&type=template&id=f6a84ec2"
import script from "./Pesos.vue?vue&type=script&lang=js"
export * from "./Pesos.vue?vue&type=script&lang=js"

import "./Pesos.vue?vue&type=style&index=0&id=f6a84ec2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__